import Vue from 'vue';
// eslint-disable-next-line
export const doorlocksLogsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/doorlocks/doorlocksLogsEventBus.js